<script setup lang="ts">
import { useSchoolStore } from "@/store/school";
import { useWindowSize } from "@vueuse/core";
import { useDefaultStore } from "@/store";
import { useSessionStore } from "@/store/session";

defineOptions({
	name: "school",
});
definePage({
	name: "school",
	path: "/school",
	redirect: "/school/school-setup",
	meta: {
		roleIds: [1, 2],
	},
});

const sessionStore = useSessionStore();
const store = useDefaultStore();
const schoolStore = useSchoolStore();
const { width } = useWindowSize();
const route = useRoute();

const isCollapsedSidebar = computed(() => {
	return (
		route.name === "school.class-management.calendar" || width.value <= 1156
	);
});

watch(
	() => route.fullPath,
	() => {
		if (schoolStore.isVisibleSchoolSidebar)
			schoolStore.isVisibleSchoolSidebar = false;
	},
);

onMounted(async () => {
	schoolStore.activeStep = store.setActiveStep(
		route.name,
		schoolStore.schoolMenuItems,
	);
	schoolStore.schoolData = await schoolStore.fetchSchoolData(
		sessionStore.userData.scl_id,
	);
});
</script>

<template>
	<div id="school-page">
		<div>
			<sidebar-comp
				:menu-items="schoolStore.schoolMenuItems"
				:is-collapsed="isCollapsedSidebar"
				:sidebar-active-step="schoolStore.activeStep"
				:school-sub-active="schoolStore.isSubActive"
				@sidebar-active-step-change="(e) => (schoolStore.activeStep = e)"
				@update:is-collapsed="schoolStore.isVisibleSchoolSidebar = true"
			/>
		</div>
		<div class="page">
			<school-header-bar />

			<router-view></router-view>
		</div>
	</div>
</template>

<style lang="scss" scoped>
#school-page {
	min-height: 100vh;
	width: 100%;
	display: flex;
	user-select: none;
	box-sizing: border-box;
	.page {
		flex-grow: 1;
		overflow-x: auto;
	}
	.banner-section {
		flex: 1;
	}
}
</style>
